export default {"src":"/_next/static/media/ACCOUNT_BLOCKED.9d5f3475.svg","height":36,"width":34,"blurWidth":0,"blurHeight":0};